import { Box, SkeletonRectangle, Text } from '@wix/design-system';
import {
  ECLIPSE_SALE_TEXT_COLOR,
  useSwitchFlows,
  MoneyBackIcon,
  useCredit,
} from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { SlidingMoneyBackGuarantee } from './SlidingMoneyBackGuarantee';
import s from './HeaderBanner.scss';

export const PromotionalMessage = () => {
  const { Trans } = EclipsePackagePickerModule.internals.useTranslations();
  const { isSwitchFlow, isLoading: isSwitchFlowLoading } = useSwitchFlows();
  const credit = useCredit();

  const isLoading = isSwitchFlowLoading || credit.isLoading;

  if (isLoading) {
    return (
      <Box align="center">
        <SkeletonRectangle height="24px" width="300px" />
      </Box>
    );
  }

  if (isSwitchFlow) {
    if (!credit.isLowCredit) {
      return (
        <Box align="center">
          <Text size="medium" weight="normal">
            <Trans
              i18nKey="app.second_upgrade_optimization.subtitle"
              values={{
                credit: credit.formattedValue,
                currentPlan: credit.currentPlan,
              }}
              components={{
                creditPart: <Text skin="success" />,
              }}
            />
          </Text>
        </Box>
      );
    }

    // Low credits - with icon
    return (
      <Box className={s.promotionalItem}>
        <MoneyBackIcon width={24} height={24} color={ECLIPSE_SALE_TEXT_COLOR} />
        <Text size="medium" weight="normal">
          <Trans
            i18nKey="app.second_upgrade_text.mobile"
            components={[<Text className={s.saleText} />]}
          />
        </Text>
      </Box>
    );
  }

  return <SlidingMoneyBackGuarantee />;
};
